import { Injectable, Output, EventEmitter } from '@angular/core';
import { AppSettings } from 'src/app/app.settings';
import { environment } from 'src/environments/environment';
import { Settings } from 'src/app/app.settings.model';
import { FindTimeModel } from '../models/find-time-model';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { FindTimeResultItem } from '../models/find-time-result-item-model';
import { Arguments } from '../models/arguments';
import { TreatmentEntity } from '../interfaces/treatment-entity';
import { AppointmentModel } from '../models/appointment-model';
import { VisitItem } from '../models/visit-item';
import { Utils } from '../utils';
import { TranslateService } from '@ngx-translate/core';
import { PriceListCode } from '../models/price-list-code';
import { TreatmentType } from '../enums';
import { PricelistCodeFilterPipe } from 'src/app/pages/treatments/pricelist-code-filter.pipe';
import { AppData } from 'src/app/app.data';



@Injectable({
  providedIn: 'root'
})
export class FindTimeService {

  settings: Settings;
  apiEndPoint: string =  Utils.getApiEndPoint(); // environment.APIEndpoint;

  constructor(private http: HttpClient,
              private appSettings: AppSettings,
              private appData: AppData,
              private translate: TranslateService) {

    this.settings = appSettings.settings;
  }

  hasTreatmentsTodo(customerID:number){
    return this.http.get<any>(this.apiEndPoint + `TreatmentApi/HasTodoTreatments/${customerID}`)
      .pipe(map(result => {
        return result;
      }));
  }

  findTimeGroup(dataToSend: FindTimeModel) {    
    return this.http.post<any>(this.apiEndPoint + `FindTimeApi/FindFreeTimeGroup`, JSON.stringify(dataToSend))
      .pipe(map(result => {
        return result;
      }));
  }

  findTime(dataToSend: FindTimeResultItem) {
    return this.http.post<any>(this.apiEndPoint + `FindTimeApi/FindFreeTime`, JSON.stringify(dataToSend))
      .pipe(map(result => {
        return result;
      }));
  }

  getPriceList(args: Arguments) {
    return this.http.post<any>(this.apiEndPoint + `TreatmentApi/GetPriceLists`, JSON.stringify(args))
      .pipe(map(result => {
        return result;
      }));
  }

  getPriceListCodes(args: Arguments) {
    return this.http.post<any>(this.apiEndPoint + `TreatmentApi/GetPriceListCodes`, JSON.stringify(args))
      .pipe(map(result => {
        return result;
      }));
  }

  getDaysOfWeek(args: Arguments) {
    // get active daysOfWeek
    return this.http.post<any>(this.apiEndPoint + `SchedulerApi/GetDaysOfWeek`, JSON.stringify(args))
      .pipe(map(result => {
        return result;
      }));
  }

  getCustomerTreatments(args: Arguments) {

    if (!args.CustomerID) {
      alert('Invalid customerId');
      return;
    }

    // get active daysOfWeek
    return this.http.post<any>(this.apiEndPoint + `TreatmentApi/GetCustomerTreatments`, JSON.stringify(args))
      .pipe(map(result => {
        return result; // return response as { Code: number, Data = { treatmentGroup, treatments}}
      }));
  }

  getDefaultTreatment(schedulerID:number, customerID: number){
    return this.http.get<any>(this.apiEndPoint + `TreatmentApi/GetDefaultTreatment/${schedulerID}/${customerID}`)
      .pipe(map(result => {
        return result;
      }));
  }

}
